import cn from 'classnames'
import { InputHTMLAttributes, forwardRef } from 'react'

import styles from './NativeInput.module.scss'

export interface NativeInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  variant?: 'default'
  size?: 'heading-l' | 'heading-m' | 'heading-s' | 'body-m' | 'body-s' | 'body-l' | 'caption'
  bold?: boolean
}

function NativeInput(
  { variant = 'default', size = 'body-m', type = 'text', bold, className, ...props }: NativeInputProps,
  ref: React.ForwardedRef<HTMLInputElement>
) {
  return (
    <input
      ref={ref}
      type={type}
      className={cn(styles.root, styles[variant], styles[size], bold && styles.bold, className)}
      {...props}
    />
  )
}

export default forwardRef(NativeInput)
